var _defs, _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.36 16.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-956.34 -527.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M956.34 527.43h16.36v16.36h-16.36z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-956.34 -527.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M956.84 535.61a7.68 7.68 0 107.68-7.67 7.68 7.68 0 00-7.68 7.67"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-2{clip-path:url(#clip-path)}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M964.52 543.28a7.67 7.67 0 10-7.68-7.67 7.67 7.67 0 007.68 7.67",
    transform: "translate(-956.34 -527.43)",
    fill: "#00393f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#96388d",
    d: "M8.41 3.68h-.28L7.7 6.82 5.17 4.91l-.19.19 1.91 2.55-3.14.44v.27l3.1.47-1.87 2.5.19.19 2.5-1.87.46 3.12h.28l.45-3.16 2.53 1.91.2-.19L9.66 8.8l3.16-.44v-.27l-3.16-.44 1.93-2.55-.2-.19-2.53 1.91-.45-3.14z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18 15.85A7.67 7.67 0 10.5 8.18a7.67 7.67 0 007.68 7.67z",
    stroke: "#96388d",
    strokeWidth: 1.02,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.f6a2a261.svg";
export { ForwardRef as ReactComponent };